import { Component, Input } from '@angular/core';

@Component({
  selector: 'cl-ui-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {
  @Input() show = true;
}
